import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GetAllPracticesResponse } from "@/core/types/(api)/practice";
import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { getPracticeList } from "../queryFunctions/getPracticeList";
import { practiceKeys } from "../keyFactory";

type UsePracticeListProps<TData = GetAllPracticesResponse> = {
  select?: (data: GetAllPracticesResponse) => TData;
};

type PracticeListQueryOptions = UseQueryOptions<
  GetAllPracticesResponse,
  unknown,
  GetAllPracticesResponse,
  ReturnType<typeof practiceKeys.list>
>;

function optionFactory() {
  return {
    queryFn: getPracticeList,
    queryKey: practiceKeys.list(),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies PracticeListQueryOptions;
}

export function usePracticeList<TData = GetAllPracticesResponse>({
  select,
}: UsePracticeListProps<TData> = {}) {
  return useQuery({ ...optionFactory(), select });
}
